module.exports = __webpack_public_path__ + "media/images/eyecatch-inquiry-sm-1fb859ec597f813cc65d92feb4e140cf.svg";